module.exports = __webpack_public_path__ + "static/media/14(3).fb3fb180.jpg";